<template>
  <div>
    <el-tabs active-name="base">
      <el-tab-pane v-for="item in tab" :label="item.title" :name="item.id">
        <xform :config="item.form.config" :data="item.form.data" @submitSuccess=""></xform>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Xform from 'xelement/form'
import { api } from 'src/config.js'

export default {
  props: [],
  data() {
    return {
      tab: [
        {
          id: 'base',
          title: '基本配置',
          form: {
            data: api.config.getAll,
            config: {
              base: {
                labelWidth: '100px'
              },
              submit: {
                btnText: '提交',
                url: ''
              },
              item: [
                [{
                  id: 'worker_def_earning',
                  title: '默认师傅扣点',
                  type: 'number',
                  config: {
                    min: 0,
                    max: 99,
                    step: 1
                  }
                }],
                [{
                  id: 'recharge_fee',
                  title: '提现手续费',
                  type: 'number',
                  config: {
                    min: 0,
                    max: 99,
                    step: 1
                  }
                }]
              ]
            }
          }
        },
        {
          id: 'remind',
          title: '跟单提醒',
          form: {
            data: api.config.getAll,
            config: {
              base: {
                labelWidth: '100px'
              },
              submit: {
                btnText: '提交',
                url: ''
              },
              item: [
                [{
                  id: 'notice_send',
                  title: '默认下单提醒',
                  type: 'textarea',
                  config: {
                    rows: 2,
                    autosize: {
                      minRows: 2, 
                      maxRows: 6
                    }
                  }
                }],
                [{
                  id: 'notice_assign',
                  title: '默认接单前提醒',
                  type: 'textarea',
                  config: {
                    rows: 2,
                    autosize: {
                      minRows: 2, 
                      maxRows: 6
                    }
                  }
                }],
                [{
                  id: 'notice_receive',
                  title: '默认接单状态提醒',
                  type: 'textarea',
                  config: {
                    rows: 2,
                    autosize: {
                      minRows: 2, 
                      maxRows: 6
                    }
                  }
                }],
                [{
                  id: 'notice_contact',
                  title: '默认联系客户状态提醒',
                  type: 'textarea',
                  config: {
                    rows: 2,
                    autosize: {
                      minRows: 2, 
                      maxRows: 6
                    }
                  }
                }],
                [{
                  id: 'notice_sign',
                  title: '默认签到状态提醒',
                  type: 'textarea',
                  config: {
                    rows: 2,
                    autosize: {
                      minRows: 2, 
                      maxRows: 6
                    }
                  }
                }],
                [{
                  id: 'notice_finish',
                  title: '默认完成状态提醒',
                  type: 'textarea',
                  config: {
                    rows: 2,
                    autosize: {
                      minRows: 2, 
                      maxRows: 6
                    }
                  }
                }],
                [{
                  id: 'notice_cancel',
                  title: '默认取消状态提醒',
                  type: 'textarea',
                  config: {
                    rows: 2,
                    autosize: {
                      minRows: 2, 
                      maxRows: 6
                    }
                  }
                }]
              ]
            }
          }
        },
        {
          id: 'remindTime',
          title: '提醒时间',
          form: {
            data: api.config.getAll,
            config: {
              base: {
                labelWidth: '100px'
              },
              submit: {
                btnText: '提交',
                url: ''
              },
              item: [
                [{
                  id: 'notice_time_contact',
                  title: '接单后提醒',
                  type: 'number',
                  config: {
                    min: 0,
                    max: 99,
                    step: 1
                  }
                }],
                [{
                  id: 'notice_time_sign',
                  title: '上门服务前',
                  type: 'number',
                  config: {
                    min: 0,
                    max: 99,
                    step: 1
                  }
                }],
                [{
                  id: 'notice_time_finish',
                  title: '超过服务时间后',
                  type: 'number',
                  config: {
                    min: 0,
                    max: 99,
                    step: 1
                  }
                }],
                [{
                  id: 'notice_delay',
                  title: '延时订单下次提醒时间',
                  type: 'number',
                  config: {
                    min: 0,
                    max: 99,
                    step: 1
                  }
                }]
              ]
            }
          }
        }
      ]
    }
  },
  creatd(){

  },
  methods: {

  },
  components: {
    Xform
  }
}
</script>


// WEBPACK FOOTER //
// setting.vue?2d29b64f